<template>
  <div class="peltier-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Q = π · I | 半导体制冷原理$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Semiconductor Junctions -->
          <g v-for="i in 4" :key="i" :transform="`translate(${80 + i*50}, 100)`">
             <rect x="0" y="0" width="20" height="40" :fill="i%2===0 ? '#ff4757' : '#00d2ff'" stroke="#fff" />
             <text x="5" y="25" fill="#fff" font-size="8">{{ i%2===0 ? 'P' : 'N' }}</text>
          </g>

          <!-- Top Plates (Cold Side) -->
          <rect x="100" y="80" width="200" height="20" :fill="current > 0 ? '#00d2ff' : '#444'" stroke="#fff" opacity="0.6" />
          <text x="170" y="70" fill="#00d2ff" font-size="10">冷端 (吸热)</text>
          <g v-if="current > 50" transform="translate(200, 90)">
             <circle r="2" fill="#fff" opacity="0.6">
                <animate attributeName="r" values="2;8;2" dur="2s" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Bottom Plates (Hot Side) -->
          <rect x="100" y="140" width="200" height="20" :fill="current > 0 ? '#ff4757' : '#444'" stroke="#fff" opacity="0.6" />
          <text x="170" y="175" fill="#ff4757" font-size="10">热端 (放热)</text>

          <!-- Circuit dots (Current flow) -->
          <g v-if="current > 0">
             <circle v-for="n in 10" :key="n" r="2" fill="#ffd700">
                <animateMotion :path="`M 80,140 L 320,140`" :dur="`${50/current}s`" repeatCount="indefinite" />
             </circle>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>工作电流 I: {{ current }} mA</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节工作电流</label>
             <el-slider v-model="current" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>皮尔效应是塞贝克效应的逆过程。当电流通过两类不同半导体构成的接点时，热量会在接点处释放或吸收。通过 Peltier 组件，电能可以直接驱动热量从一端搬运到另一端，实现**固态制冷**。它常用于电子设备的静音冷却、车载冰箱及精密医疗仪器的恒温控制。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeltierEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      current: 40
    }
  }
}
</script>

<style scoped lang="scss">
.peltier-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
